import factory from "./factory";

const responseTransform = (response) => response.data;

const errorTransform = (error) => {
  throw new Error({
    code: error?.response?.status,
    message: error?.response?.data || "An error has occurred",
  });
};

const accountApi = factory({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/account/`,
  responseTransform,
  errorTransform,
});

const accountRequest = (params) =>
  accountApi({ ...params, authToken: sessionStorage.AUTH_TOKEN });

export default accountRequest;
